"use client";

import { motion, useReducedMotion } from "framer-motion";
import { ArrowRight, CircleQuestionMark as HelpCircle } from 'lucide-react';
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function Replacement() {
  const shouldReduceMotion = useReducedMotion();
  return <section id="replacementpartcta" data-nav="dark" className="relative overflow-hidden bg-primary py-20 text-primary-foreground sm:py-24 lg:py-28">
      {/* Industrial mechanical background accents */}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_top,_var(--color-primary-foreground)/0.08,_transparent_70%)]" />
      <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 left-0 w-px bg-primary-foreground/15" />
      <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 right-0 w-px bg-primary-foreground/15" />

      <div className="container relative mx-auto max-w-5xl px-4 sm:px-6 lg:px-8">
        <motion.div initial={shouldReduceMotion ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.3,
        ease: [0.16, 1, 0.3, 1]
      }} className="relative mx-auto border border-primary-foreground/25 bg-primary p-8 text-center sm:p-12 lg:p-16">
          {/* Architectural plate corner notches */}
          <div aria-hidden="true" className="absolute top-0 left-0 size-3 border-t-2 border-l-2 border-primary-foreground" />
          <div aria-hidden="true" className="absolute top-0 right-0 size-3 border-t-2 border-r-2 border-primary-foreground" />
          <div aria-hidden="true" className="absolute bottom-0 left-0 size-3 border-b-2 border-l-2 border-primary-foreground" />
          <div aria-hidden="true" className="absolute bottom-0 right-0 size-3 border-b-2 border-r-2 border-primary-foreground" />

          {/* Heading */}
          <h2 className="font-serif text-3xl font-bold tracking-tight text-primary-foreground uppercase sm:text-4xl md:text-5xl lg:text-6xl">
            Need a Mechanical Bull Replacement Part?
          </h2>

          {/* Body paragraphs */}
          <div className="mx-auto mt-6 max-w-3xl space-y-4 font-sans text-base leading-relaxed text-primary-foreground/90 sm:text-lg">
            <p>
              Start with the part you are replacing and the machine it came from.
              The more accurately you identify the model, existing component and
              connections, the easier it becomes to narrow down the available
              options.
            </p>
            <p>
              Browse the current mechanical bull parts and accessories, or send us
              the product details and photos you have if you are unsure which
              component to enquire about.
            </p>
          </div>

          {/* Action buttons */}
          <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row sm:gap-6">
            <motion.div whileTap={shouldReduceMotion ? {} : {
            scale: 0.99
          }} className="w-full sm:w-auto">
              <Button asChild size="lg" className="w-full rounded-none bg-secondary px-7 py-6 text-sm font-semibold tracking-wider text-secondary-foreground uppercase shadow-md transition-colors hover:bg-secondary/85 sm:w-auto">
                <Link to="#">
                  <span>BROWSE MECHANICAL BULL PARTS</span>
                  <ArrowRight className="size-4" />
                </Link>
              </Button>
            </motion.div>

            <motion.div whileTap={shouldReduceMotion ? {} : {
            scale: 0.99
          }} className="w-full sm:w-auto">
              <Button asChild variant="outline" size="lg" className="w-full rounded-none border-primary-foreground bg-transparent px-7 py-6 text-sm font-semibold tracking-wider text-primary-foreground uppercase shadow-none transition-colors hover:bg-primary-foreground/15 hover:text-primary-foreground sm:w-auto">
                <Link to="/ContactPage">
                  <HelpCircle className="size-4" />
                  <span>ASK ABOUT A PART</span>
                </Link>
              </Button>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>;
}